/**
 * Formats any number as $0,000.00
 * @param {number | string} value Number to convert to currency. Dollar, here, is the generic term for floats that just need visual touchups
 * @param {string} currencyCode Convert value into this type currency
 * @returns {string} string like '$1,000.00'
 */
export var formatDollarToCurrency = function (value, currencyCode) {
    if (currencyCode === void 0) { currencyCode = 'USD'; }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode
    });
    return formatter.format(Number(value));
};
/**
 * Formats currency object from back end into an actual currency string
 * @param {PenniesToCurrencyProps} currencyValue object returned from back end representing cents and currencyCode. Pennies, here, is the generic term for backend values to be divided
 * @returns {string} string like '$1,000.00'
 */
export var formatPenniesToCurrency = function (_a) {
    var value = _a.value, currencyCode = _a.currencyCode;
    var float = Number(value);
    if (currencyCode === 'USD') {
        float /= 100;
    }
    return formatDollarToCurrency(float, currencyCode);
};
//# sourceMappingURL=formatCurrency.js.map